import { api, UploadedMedia } from '../../../lib/api';
import type { TeamMessage } from '../../../lib/websocket/events';

export interface TeamChannel {
  id: string;
  storeId: string;
  name: string;
  isDefault: boolean;
}

// The team-chat API already returns camelCase, so no snake_case mapping needed.
export const teamChatService = {
  async getChannels(): Promise<TeamChannel[]> {
    return api.get<TeamChannel[]>('/team/channels');
  },

  async getMessages(
    channelId: string,
    opts: { limit?: number; before?: string } = {}
  ): Promise<TeamMessage[]> {
    return api.get<TeamMessage[]>(`/team/channels/${channelId}/messages`, {
      params: { limit: opts.limit ?? 50, ...(opts.before ? { before: opts.before } : {}) },
    });
  },

  async sendMessage(
    channelId: string,
    content: string,
    media?: UploadedMedia
  ): Promise<TeamMessage> {
    const body: Record<string, any> = { content };
    if (media) {
      body.media_url = media.mediaUrl;
      body.media_type = media.mediaType;
      body.media_mime_type = media.mimeType;
      body.file_name = media.fileName;
    }
    return api.post<TeamMessage>(`/team/channels/${channelId}/messages`, body);
  },
};
